import { useState, useCallback } from 'react';
import { useAppDispatch } from '../store/hooks';
import { addToCart, setIsCartOpen, type Product } from '../store/cartSlice';

export function useCartActions() {
  const dispatch = useAppDispatch();
  const [addedId, setAddedId] = useState<string | null>(null);

  const addToCartFn = useCallback((product: Product, size?: string) => {
    const chosenSize = size ?? (product.sizes?.split(', ')[0]?.trim() ?? 'Único');
    dispatch(addToCart({ product, size: chosenSize }));
    setAddedId(product.id);
    setTimeout(() => setAddedId(null), 1500);
  }, [dispatch]);

  const buyNow = useCallback((product: Product, size?: string) => {
    const chosenSize = size ?? (product.sizes?.split(', ')[0]?.trim() ?? 'Único');
    dispatch(addToCart({ product, size: chosenSize }));
    dispatch(setIsCartOpen(true));
  }, [dispatch]);

  const isAdded = (productId: string) => addedId === productId;

  return { addToCartFn, buyNow, isAdded };
}
